<template>
  <div class="forgotPassword">
    <ForgotPassword />
  </div>
</template>

<script>
// @ is an alias to /src
import ForgotPassword from "@/components/forgotPassword.vue";

export default {
  name: "forgotPassword",
  components: {
    ForgotPassword
  }
};
</script>
<style scoped lang="scss">
.forgotPassword {
  background-color: #fff;
  word-break: break-word;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  // background-image: url(../assets/d_bg.svg);
  // background-size: auto;
  // background-repeat: no-repeat;
  // background-position: left;
}
</style>
